import { SUB_STRING_CODE } from '@core/constants/CONSTANTS';
import { getKeyByValue, getMainBodyBaseLayout, lowerCaseLessFirstLetter } from './utils';
import { MAPPED_VIDEO_ED_TYPE } from '@core/constants/FILTERS';
import { FILTERS_WEB_COMPONENT } from '@core/constants/WEB-COMPONENT-KEYS';
import { CUSTOM_FILTER_CHIP_WEB_COMPONENT } from '@components/Filters/components/CustomFilterChip/CONSTANTS';

/**
 * Remove the prefix filter.
 * @param {string} filter - Filter to remove the prefix.
 * @returns {string} - The filter without the prefix.
 */
export const removePrefixFilter = (filter) => {
    return filter.split(':')[1];
};

/**
 * Create the common code to filter the edited videos
 * @param {string} typeValue - The type of the report.
 * @returns {string}
 */
export const commonCodeCreateEdVideoFilter = (typeValue) => {
    return `${SUB_STRING_CODE.VID_ED_TYPE}${lowerCaseLessFirstLetter(
        getKeyByValue(MAPPED_VIDEO_ED_TYPE, typeValue),
    )}`;
};

/**
 * Get the filters web component.
 * @returns {NodeListOf<HTMLElement>}
 */
export const getFiltersFromFiltersComponent = () => {
    return (
        getMainBodyBaseLayout()
            ?.querySelector(FILTERS_WEB_COMPONENT)
            ?.shadowRoot?.querySelector('[data-activated-filters]')
            ?.querySelectorAll(CUSTOM_FILTER_CHIP_WEB_COMPONENT) || null
    );
};
